import { render, staticRenderFns } from "./AnnuityRefundForm.vue?vue&type=template&id=7a163f28&scoped=true"
import script from "./AnnuityRefundForm.vue?vue&type=script&lang=js"
export * from "./AnnuityRefundForm.vue?vue&type=script&lang=js"
import style0 from "./AnnuityRefundForm.vue?vue&type=style&index=0&id=7a163f28&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a163f28",
  null
  
)

export default component.exports